import { FunctionalMovementKinematicsGraph } from '@/pages/ReportV2/components/Graphs';

interface SquatReportChartProps {
  PDFDownloadData: any;
  ChartComponentRefs: any;
}

export const SquatReportCharts = ({ PDFDownloadData, ChartComponentRefs }: SquatReportChartProps) => {
  return (
    <div style={{ display: 'none' }}>
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Sagittal.series}
        forPdf={true}
        ref={ChartComponentRefs['pelvisKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Anterior tilt (-) / Posterior tilt (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Sagittal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Coronal.series}
        forPdf={true}
        ref={ChartComponentRefs['pelvisKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Drop (-) / Hike (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Coronal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Transversal.series}
        forPdf={true}
        ref={ChartComponentRefs['pelvisKinematicTransversal']}
        strokeWidth={2}
        subtitle={'Backward Rotation (-) / Forward Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Transversal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.hipKinematicData.Sagittal.series}
        forPdf={true}
        ref={ChartComponentRefs['hipKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Extension (-) / Flexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.hipKinematicData.Sagittal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.hipKinematicData.Coronal.series}
        forPdf={true}
        ref={ChartComponentRefs['hipKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Abduction (-) / Adduction (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.hipKinematicData.Coronal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.hipKinematicData.Transversal.series}
        forPdf={true}
        ref={ChartComponentRefs['hipKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.hipKinematicData.Transversal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Sagittal.series}
        forPdf={true}
        ref={ChartComponentRefs['kneeKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Extension (-) / Flexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.kneeKinematicData.Sagittal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Coronal.series}
        forPdf={true}
        ref={ChartComponentRefs['kneeKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Valgus (-) / Varus (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.kneeKinematicData.Coronal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Transversal.series}
        forPdf={true}
        ref={ChartComponentRefs['kneeKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.kneeKinematicData.Transversal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Sagittal.series}
        forPdf={true}
        ref={ChartComponentRefs['ankleKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Plantarflexion (-) / Dorsalflexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.ankleKinematicData.Sagittal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Coronal.series}
        forPdf={true}
        ref={ChartComponentRefs['ankleKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Eversion (-) / Inversion (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.ankleKinematicData.Coronal.yAxis}
      />
      <FunctionalMovementKinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Transversal.series}
        forPdf={true}
        ref={ChartComponentRefs['ankleKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.ankleKinematicData.Transversal.yAxis}
      />
    </div>
  );
};
